import { storeToRefs } from "pinia";
import Http from "../services/http.service";
import { useUserStore } from '../store/userStore';
import { HttpStatusCode } from "axios";
import { useLocalStorage } from "./useLocalStorage";

export const useAuth = () => {
    
    const userStore = useUserStore();
    const { 
        user,
        company,
        isLoading,
    } = storeToRefs( userStore );

    const { getUserInfo, getUserCompanyInfo } = useLocalStorage();

    const login = async (userData) => {
        try {
            const { status, data } = await Http.post('/api/auth/login', userData);
            // Sesión única: la cuenta ya tiene otra sesión abierta. Sin token;
            // la vista pide confirmar y reenvía con `force: true`.
            if (status === HttpStatusCode.Conflict && data?.code === 'SESSION_ACTIVE') {
                return {
                    success: false,
                    sessionActive: true,
                    activeSession: data.activeSession || null,
                }
            }
            // 5 intentos por correo cada 15 min (el reintento con `force` cuenta).
            if (status === HttpStatusCode.TooManyRequests) {
                return { success: false, rateLimited: true }
            }
            if(status === HttpStatusCode.Ok){
                // Caso (c): el email existe en varias empresas (ninguna master) →
                // todavía NO hay token/user/company; el FE muestra el selector y
                // reenvía las credenciales + companyId elegido.
                if (data?.requiresCompanySelection) {
                    return {
                        success: true,
                        requiresSelection: true,
                        options: data.options || []
                    }
                }
                userStore.loadUser(data.user);
                userStore.loadCompany(data.company);
                return {
                    success: true,
                    data
                }
            }
            return {
                success: false,
                data: null
            }
        } catch (error) {
            console.log(error);
            return {
                success: false,
                data: null
            }
        }
    }

    const onUpdateUserProfile = async (userData) => {
        try {
            const { status } = await Http.put('/api/users', userData);
            if(status === HttpStatusCode.Ok){
                userStore.loadUser(userData);
                localStorage.setItem("gs-user", JSON.stringify(userData));
                return true;
            } 
            return false
        } catch (error) {
            console.log(error);
        }
    }

    const onUpdateUserPwd = async (obj) => {
        try {
            const { status } = await Http.post('/api/users/pwd', obj);
            if(status === HttpStatusCode.Ok){
                return true;
            } 
            return false;
        } catch (error) {
            console.log(error);
        }
    }

    const getUserProfile = () => {
        if(user.value === null){
            const userInfo = getUserInfo();
            if(userInfo !== null){
                userStore.loadUser(userInfo);
            }
        }
        return user;
    }
    const getCompanyInfo = () => {
        if(company.value === null){
            const companyInfo = getUserCompanyInfo();
            if(companyInfo !== null){
                userStore.loadCompany(companyInfo);
            }
        }
        return user;
    }
    

    const uploadUserAvatar = async (obj) => {
        try {
          
            const { data } = await Http.post(`/api/users/upload-avatar`, obj, {
                headers: {
                "Content-Type": "multipart/form-data"
                }
            });
            return data;

        } catch (error) {
          console.log('Error updating avatar', error);
        }
    }

    const onUpdateUserResetPwd = async (obj) =>{
        try {
          
            await Http.post('/api/users/reset-pwd', obj);
            return true;

        } catch (error) {
          console.log('Error changing pwd', error);
        }
    }

    return{
        user,
        company,
        isLoading,
        login,
        getCompanyInfo,
        getUserProfile,
        onUpdateUserPwd,
        getUserCompanyInfo,
        onUpdateUserProfile,
        uploadUserAvatar,
        onUpdateUserResetPwd
    }
}